import BaseService from './_base.service';

export const cameraService = {
    page,
    edit,
    search,
    create,
    combo,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/camera/page/"+page+"/"+size, callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/camera/page/"+page+"/"+size,filter, callback, true)
}
function combo(callback) {
    return BaseService.get("/camera/combo/", callback, true)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/camera/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/camera/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/camera/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/camera/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/camera/"+id+"/logic", callback);
}
